import {Observable} from 'rxjs';
import {Resolve} from '@angular/router';
import {EmisionCfeService} from '../services/emision-cfe.service';
import {Injectable} from '@angular/core';
import {KeycloakService} from 'keycloak-angular';
import {DatosInicioEmisionCFEDTO} from '../../models/dtos/datosInicio/DatosInicioEmisionCFEDTO';
import {ParamEmisionCFEResolverDTO} from '../../models/dtos/ParamEmisionCFEResolverDTO';

@Injectable()
export class EmisionCfeResolver implements Resolve<Observable<DatosInicioEmisionCFEDTO>>
{
  constructor(private emisionCfeService: EmisionCfeService, private keycloakService: KeycloakService)
  {

  }

  public resolve(): Observable<Observable<DatosInicioEmisionCFEDTO>> | Promise<Observable<DatosInicioEmisionCFEDTO>> | Observable<DatosInicioEmisionCFEDTO>
  {
    const paramEmisionCFEResolverDTO: ParamEmisionCFEResolverDTO = new ParamEmisionCFEResolverDTO();
    paramEmisionCFEResolverDTO.email = this.keycloakService.getUsername();

    return this.emisionCfeService.obtenerConfiguracionInicialEmisionCFE(paramEmisionCFEResolverDTO);
  }
}
